module.exports = __webpack_public_path__ + "static/media/program-learn-main-3.2df26313.png";